exports.register = (module) ->
    module.factory 'Core.Services.MapLayers.Base', [
        '$http', 'Core.Services.Map', '$q', (args...) ->
            # OKAY. So, this is kind of a little stupid. Turns out
            # that 'factory' in angular is not actually a factory!
            # Factories are still cachecd by the injector, meaning they
            # are always singletons, just like module.service registrations
            # are. If you want an actual FACTORY, you need to return an
            # object with a method that creates instances for you, because
            # reasons.
            return {
                new: () ->
                    service = new exports.Base(args...)
                    service.geojson = null

                    return service
            }
    ]

class exports.Base
    constructor: (@http, @mapService, @promise) ->
        undefined

    # Take a 'query' object (just object of params to
    # pass through) and a map layer (feature group or
    # maybe even a map itself) to add the geojson onto
    # automatically.
    display: (query, layer, styling = {}) =>
        if not @geojson?
            @_display(
                layer,
                @url,
                query,
                styling
            ).then (response) =>
                @geojson = response
                @setOpacity(@opacity) if @opacity?
                return response
            , (response) =>
                return @promise.reject(response)

        else
            promise = @promise.defer()
            layer.addLayer(@geojson)
            @layer_added_to = layer
            promise.resolve(@geojson)
            return promise.promise

    # hide the geojson from the specified layer.
    hide: (layer) =>
        if @geojson?
            layer.removeLayer(@geojson)


    # Takes opacity as an integer, where 0 is totally
    # transparent and 100 is totally opaque
    setOpacity: (value) =>
        @opacity = value
        return if not @geojson?

        fill = (value / 100).toFixed(2)
        line = ((value + 100) / 200).toFixed(2)

        @geojson.eachLayer (l) ->
            l.setStyle {
                fillOpacity: fill
                opacity: line
            }


    ##### TODO: figure out how to structure this better....
    _getStyle: () =>
        return $.extend({},
           fillColor: '#00FF00',
            color: '#000000',
            opacity: 0.75
            fillOpacity: 0.3
            weight: 2
        )


    _display: (layer, url, options, style, eachFeature = null) ->
        return @http.post(url, options).then (response) =>
            json = @getGeoJSON(response)
            if not json?
                return @promise.reject(response)

            gj = @makeMapLayer(layer, json, style, eachFeature)
            response.json_layer = gj


    makeMapLayer: (layer, json, style = null, eachFeature = null) =>
        gj = @mapService.getLeaflet().geoJson json,
            style: (feature) =>
                st = $.extend(@_getStyle(), style)
                if feature.mapProperties?
                    st = $.extend(st, feature.mapProperties)
                st = $.extend(st, feature.properties)

                return st
            onEachFeature: (ft, layer) =>
                layer.feature = ft
                if eachFeature?
                    eachFeature(ft, layer)
                else
                    @propertyTable(ft, layer)

        @geojson = gj
        @layer_added_to = layer
        layer.addLayer(gj)
        return gj

    # Default method of retrieving the geojson data out of the response.
    # If a particular layer expects a different data structure from the backend,
    # it should override this method.
    getGeoJSON: (response) =>
        if not response.data.data?
            json = response.data
        else
            json = response.data.data


    # Default Properties table setup for geojson layers.
    # If a particular layer wants to format the popup output differently,
    # it should override this method.
    propertyTable: (ft, layer) =>
        if ft.properties?
            info = "
                <table class='table table-condensed margin-top-22'>
            "
            for k, v of ft.properties
                info += "<tr><td><strong>#{k}</strong></td><td>#{v}</td></tr>"

            info += '</table>'

        layer.bindPopup(info)
